import { render, staticRenderFns } from "./SwiperBase.vue?vue&type=template&id=29d21b46&scoped=true&"
import script from "./SwiperBase.vue?vue&type=script&lang=js&"
export * from "./SwiperBase.vue?vue&type=script&lang=js&"
import style0 from "./SwiperBase.vue?vue&type=style&index=0&id=29d21b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d21b46",
  null
  
)

export default component.exports